var map = {
	"./16330114394851_p1c2-1.png": 345,
	"./Logo_Circle webby text blue.png": 685,
	"./azure-sql-database6354.jpg": 65,
	"./mysql.png": 261,
	"./vignette-symfony-1-1024x614.png": 246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;